import styled from '@emotion/styled'

export const RadioLabel = styled.label({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
})
